import { render, staticRenderFns } from "./SvgLegend.vue?vue&type=template&id=2fbbb0ec&scoped=true&"
import script from "./SvgLegend.vue?vue&type=script&lang=js&"
export * from "./SvgLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbbb0ec",
  null
  
)

export default component.exports